var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1977F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5038 11.6021L12.9025 8.99995H10.4066V7.31158C10.4066 6.60029 10.7547 5.90545 11.8735 5.90545H13.0088V3.69057C13.0088 3.69057 11.9785 3.51465 10.9939 3.51465C8.93846 3.51465 7.59435 4.76004 7.59435 7.01669V8.99995H5.30859V11.6021H7.59435V17.8911C8.05251 17.9633 8.52207 18 9.00048 18C9.47889 18 9.94845 17.962 10.4066 17.8911V11.6021H12.5038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bb9d2c8695c011594b97b8074923bab2.svg";
export { ForwardRef as ReactComponent };